"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4434],{

/***/ 73445:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var getLatLng = function(item) {
    return {
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude)
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getLatLng);


/***/ }),

/***/ 30247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SelectedLockerMarkerIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "16px" : _width, _height = param.height, height = _height === void 0 ? "16px" : _height, _color = param.color, color = _color === void 0 ? "#C00033" : _color;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 11 14",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: color,
            d: "M5.5 0a5.5 5.5 0 0 0-4.22 9.03L5.5 14l4.22-4.98.17-.22a5.44 5.44 0 0 0-.5-7.19A5.5 5.5 0 0 0 5.5 0Zm2.1 5.85L5.5 8 3.4 5.85a1.4 1.4 0 0 1 .43-2.25 1.33 1.33 0 0 1 1.47.3l.2.2.2-.2a1.33 1.33 0 0 1 1.9 0 1.4 1.4 0 0 1 0 1.95Z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectedLockerMarkerIcon);


/***/ }),

/***/ 35203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Lockers_lib_isLockerInactive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33850);



var LockerCardAddress = function(param) {
    var locker = param.locker;
    var ref = locker.address || {}, locality = ref.locality, street = ref.street, county = ref.county;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (street || locality || county) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
                "text-[#767676]": (0,_components_Lockers_lib_isLockerInactive__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(locker)
            }),
            children: "".concat(street ? street + ", " : "").concat(locality ? locality + ", " : "").concat(county || "")
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LockerCardAddress);


/***/ }),

/***/ 29102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LockerCard_LockerCardCarrierBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Icons/MapMarkerIcon.js

var MapMarkerIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "32px" : _width, _height = param.height, height = _height === void 0 ? "32px" : _height, color = param.color;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 32",
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16 2a11.01 11.01 0 0 0-8.44 18.05L16 30l8.44-9.95.34-.45A11.01 11.01 0 0 0 16 2Zm0 15a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h32v32H0z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_MapMarkerIcon = (MapMarkerIcon);

// EXTERNAL MODULE: ./components/Lockers/_lib/getLockerProviderData.js
var getLockerProviderData = __webpack_require__(60666);
;// CONCATENATED MODULE: ./components/Lockers/LockerCard/LockerCardCarrierBadge.js



var LockerCardCarrierBadge = function(param) {
    var locker = param.locker;
    var ref = (0,getLockerProviderData/* default */.Z)(locker), carrierName = ref.name, color = ref.color;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: color
        },
        className: "flex items-center w-fit gap-[2px] rounded-[4px] py-[4px] pl-[4px] pr-[6px] text-[14px] font-medium text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_MapMarkerIcon, {
                color: "#fff",
                width: "16px",
                height: "16px"
            }),
            carrierName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: carrierName
            })
        ]
    }));
};
/* harmony default export */ var LockerCard_LockerCardCarrierBadge = (LockerCardCarrierBadge);


/***/ }),

/***/ 1441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Lockers_lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14003);
/* harmony import */ var _components_Lockers_lib_isLockerInactive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33850);



var LockerCardInactiveTag = function(param) {
    var locker = param.locker;
    if (!(0,_components_Lockers_lib_isLockerInactive__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(locker)) {
        return null;
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "inline-block w-fit rounded-[4px] border border-[#F1C21B]/30 bg-[#FCF4D6] px-[8px] pb-[5px] pt-[4px] text-[12px] font-medium",
        children: _components_Lockers_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .LOCKER_INACTIVE_TAG */ .Do
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LockerCardInactiveTag);


/***/ }),

/***/ 28006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Lockers_lib_isLockerInactive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33850);



var LockerCardName = function(param) {
    var locker = param.locker;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (locker === null || locker === void 0 ? void 0 : locker.name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("font-medium", {
                "text-[#767676]": (0,_components_Lockers_lib_isLockerInactive__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(locker)
            }),
            children: locker.name
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LockerCardName);


/***/ }),

/***/ 1272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var LockerCardRoutingAction = function(param) {
    var locker = param.locker;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: "https://www.google.com/maps/dir/?api=1&destination=".concat(locker.latitude, ",").concat(locker.longitude),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-red-brand underline hover:text-bleu-hover cursor-pointer inline-block",
        children: "Vezi ruta"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LockerCardRoutingAction);


/***/ }),

/***/ 33393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var LockerCardSchedule = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-[4px]",
        children: [
            "Luni - Duminica: ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-[#319D10] font-medium",
                children: "Non-stop"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LockerCardSchedule);


/***/ }),

/***/ 14003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gq": function() { return /* binding */ ACCOUNT_PAGE_MODAL_LOCKERS_MAP_ID; },
/* harmony export */   "bS": function() { return /* binding */ ACCOUNT_PAGE_MODAL_ID; },
/* harmony export */   "w0": function() { return /* binding */ PRODUCT_PAGE_LOCKERS_MAP_ID; },
/* harmony export */   "AR": function() { return /* binding */ PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID; },
/* harmony export */   "WN": function() { return /* binding */ RMA_PAGE_LOCKERS_MAP_ID; },
/* harmony export */   "LF": function() { return /* binding */ RMA_PAGE_MODAL_LOCKERS_MAP_ID; },
/* harmony export */   "Do": function() { return /* binding */ LOCKER_INACTIVE_TAG; },
/* harmony export */   "pM": function() { return /* binding */ LOCKER_INACTIVE_MESSAGE; },
/* harmony export */   "og": function() { return /* binding */ FAVOURITE_LOCKER_INACTIVE_MESSAGE; }
/* harmony export */ });
/* unused harmony export ACCOUNT_PAGE_LOCKERS_MAP_ID */
var ACCOUNT_PAGE_LOCKERS_MAP_ID = "ACCOUNT_PAGE_LOCKERS_MAP";
var ACCOUNT_PAGE_MODAL_LOCKERS_MAP_ID = "ACCOUNT_PAGE_MODAL_LOCKERS_MAP";
var ACCOUNT_PAGE_MODAL_ID = "ACCOUNT_PAGE_LOCKERS_MAP_MODAL";
var PRODUCT_PAGE_LOCKERS_MAP_ID = "PRODUCT_PAGE_LOCKERS_MAP";
var PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID = "PRODUCT_PAGE_MODAL_LOCKERS_MAP";
var RMA_PAGE_LOCKERS_MAP_ID = "RMA_PAGE_LOCKERS_MAP";
var RMA_PAGE_MODAL_LOCKERS_MAP_ID = "RMA_PAGE_MODAL_LOCKERS_MAP";
var LOCKER_INACTIVE_TAG = "Indisponibil";
var LOCKER_INACTIVE_MESSAGE = "Acest punct de ridicare este momentan indisponibil. Te rugam sa alegi altul.";
var FAVOURITE_LOCKER_INACTIVE_MESSAGE = "Punctul de ridicare salvat nu mai este disponibil. Te rugam sa alegi altul.";


/***/ }),

/***/ 60666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _components_Lockers_lib_isLockerInactive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33850);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// White-on-grey, contrast 4.5:1 — the carrier badge and the map marker both use white text
var INACTIVE_COLOR = "#767676";
var getProviderData = function(marker) {
    switch(marker.provider){
        case "fancurier":
            return {
                name: "FANbox",
                color: "#2CAAE1"
            };
        default:
            {
                return {
                    name: "Locker",
                    color: "#fff"
                };
            }
    }
};
var getLockerProviderData = function(marker) {
    var providerData = getProviderData(marker);
    return (0,_components_Lockers_lib_isLockerInactive__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(marker) ? _objectSpread({}, providerData, {
        color: INACTIVE_COLOR
    }) : providerData;
};
/* harmony default export */ __webpack_exports__["Z"] = (getLockerProviderData);


/***/ }),

/***/ 4434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LockersMapWithFilters_LockersMapWithFiltersModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/@vis.gl/react-google-maps/dist/index.modern.mjs
var index_modern = __webpack_require__(81323);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./components/Form/Select.js
var Select = __webpack_require__(66569);
// EXTERNAL MODULE: ./store/user/actions.js
var actions = __webpack_require__(49865);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./components/GoogleMap/_lib/getAvailableCitiesInRegion.js

var getAvailableCitiesInRegion = function(param) {
    var region = param.region, data = param.data;
    if (!region || (data === null || data === void 0 ? void 0 : data.length) === 0) {
        return [];
    }
    var citiesWithLockers = new Set();
    data.forEach(function(marker) {
        var ref;
        if ((0,helpers/* normalizeStringForComparison */.gv)((ref = marker.address) === null || ref === void 0 ? void 0 : ref.county) === (0,helpers/* normalizeStringForComparison */.gv)(region)) {
            citiesWithLockers.add(marker.address.locality);
        }
    });
    return Array.from(citiesWithLockers).sort(function(a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
};
/* harmony default export */ var _lib_getAvailableCitiesInRegion = (getAvailableCitiesInRegion);

;// CONCATENATED MODULE: ./components/GoogleMap/GoogleMapFilters.js







var GoogleMapFilters = function(param1) {
    var data = param1.data, regions = param1.regions, onFiltersChange = param1.onFiltersChange;
    var handleFormChange = function(param) {
        var formState = param.formState, form = param.form;
        var values = formState.values, active = formState.active;
        if (!active) {
            return;
        }
        switch(active){
            case "region":
                {
                    handleRegionChange({
                        values: values,
                        form: form,
                        active: active
                    });
                    break;
                }
            case "city":
                {
                    handleCityChange({
                        values: values,
                        form: form,
                        active: active
                    });
                    break;
                }
            case "search":
                {
                    handleSearchChange({
                        values: values,
                        form: form,
                        active: active
                    });
                    break;
                }
            default:
                return;
        }
    };
    var handleRegionChange = function(param) {
        var values = param.values, form = param.form, active = param.active;
        var region = values.region, city = values.city, search = values.search;
        if (!active || !region) {
            return;
        }
        if (city && city !== "all_cities") {
            form.change("city", "all_cities");
        }
        if (search) {
            form.change("search", null);
        }
        onFiltersChange({
            value: region,
            active: active
        });
    };
    var handleCityChange = function(param) {
        var values = param.values, form = param.form, active = param.active;
        var city = values.city, search = values.search;
        if (!active || !city) {
            return;
        }
        if (search) {
            form.change("search", null);
        }
        onFiltersChange({
            value: city,
            active: active
        });
    };
    var handleSearchChange = function(param) {
        var values = param.values, form = param.form, active = param.active;
        var search = values.search;
        if (!active) {
            return;
        }
        var ref = form.getState(), visited = ref.visited, modified = ref.modified;
        // we send emty string if search was cleared, to know that a value was previously entered
        var searchValue = visited.search && !modified.search ? null : modified.search && (search === null || search === void 0 ? void 0 : search.length) ? search : "";
        onFiltersChange({
            value: searchValue,
            active: active
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        onSubmit: function() {
            return null;
        },
        render: function(param) {
            var values = param.values, form = param.form;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                onSubmit: function(e) {
                    return e.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* FormSpy */.lP, {
                        onChange: function(formState) {
                            return handleFormChange({
                                formState: formState,
                                form: form
                            });
                        }
                    }),
                    regions && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                                component: Select/* default */.Z,
                                label: "Judet",
                                name: "region",
                                id: "GoogleMap_regionFilter",
                                inputClassName: "!max-w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "all_regions",
                                        children: "Toate judetele"
                                    }),
                                    regions && regions.map(function(region) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                            value: region.url_key,
                                            children: region.name
                                        }, region.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-[8px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_final_form_es/* Field */.gN, {
                                    component: Select/* default */.Z,
                                    label: "Localitate",
                                    name: "city",
                                    disabled: !values.region || values.region === "all_regions",
                                    id: "GoogleMap_cityFilter",
                                    inputClassName: "!max-w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "all_cities",
                                            children: "Toate localitatile"
                                        }),
                                        _lib_getAvailableCitiesInRegion({
                                            data: data,
                                            region: values.region
                                        }).map(function(city) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                value: city,
                                                children: city
                                            }, city);
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[8px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            component: InputText/* default */.Z,
                            label: "Cauta punct de ridicare",
                            name: "search",
                            id: "GoogleMap_searchFilter",
                            inputClassName: "!max-w-full"
                        })
                    })
                ]
            });
        }
    }));
};
/* harmony default export */ var GoogleMap_GoogleMapFilters = ((0,es/* connect */.$j)(function(state) {
    return {
        regions: state.user.regions
    };
}, {
    getRegions: actions/* getRegions */.JL
})(GoogleMapFilters));

// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardCarrierBadge.js + 1 modules
var LockerCardCarrierBadge = __webpack_require__(29102);
// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardRoutingAction.js
var LockerCardRoutingAction = __webpack_require__(1272);
;// CONCATENATED MODULE: ./components/Lockers/LockerCard/LockerCardPositionInfo.js

var LockerCardPositionInfo = function(param) {
    var locker = param.locker;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: locker.description ? locker.description : null
    });
};
/* harmony default export */ var LockerCard_LockerCardPositionInfo = (LockerCardPositionInfo);

// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardName.js
var LockerCardName = __webpack_require__(28006);
// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardAddress.js
var LockerCardAddress = __webpack_require__(35203);
// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardInactiveTag.js
var LockerCardInactiveTag = __webpack_require__(1441);
;// CONCATENATED MODULE: ./components/Lockers/LockerInfoWindow.js







var LockerInfoWindowHeader = function(param) {
    var marker = param.marker;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LockerCardCarrierBadge/* default */.Z, {
        locker: marker
    });
};
var LockerInfoWindowContent = function(param) {
    var marker = param.marker;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "mt-[6px] space-y-[4px] text-[14px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardName/* default */.Z, {
                locker: marker
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardAddress/* default */.Z, {
                locker: marker
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardInactiveTag/* default */.Z, {
                locker: marker
            }),
            marker.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-[4px] text-[12px] text-gray-1600",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCard_LockerCardPositionInfo, {
                    locker: marker
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-[8px] text-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardRoutingAction/* default */.Z, {
                    locker: marker
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ./components/Lockers/_lib/getLockerProviderData.js
var getLockerProviderData = __webpack_require__(60666);
;// CONCATENATED MODULE: ./components/Lockers/LockerMarker.js



var LockerMapMarker = /*#__PURE__*/ (0,react.memo)(function(param) {
    var marker = param.marker;
    var ref = (0,getLockerProviderData/* default */.Z)(marker), name = ref.name, color = ref.color;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: color,
            position: "relative"
        },
        className: "text-white text-[12px] font-medium px-[6px] py-[4px] rounded",
        children: [
            name,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    bottom: "-6px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "6px solid transparent",
                    borderRight: "6px solid transparent",
                    borderTop: "6px solid ".concat(color)
                }
            })
        ]
    }));
});
LockerMapMarker.displayName = "LockerMapMarker";
/* harmony default export */ var LockerMarker = (LockerMapMarker);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Lockers/LockerCard/LockerCardSchedule.js
var LockerCardSchedule = __webpack_require__(33393);
;// CONCATENATED MODULE: ./lib/useSlidingWindow.js

var useSlidingWindow = function(param) {
    var _data = param.data, data = _data === void 0 ? [] : _data, scrollContainerRef = param.scrollContainerRef, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 30 : _pageSize, _overlap = param.overlap, overlap = _overlap === void 0 ? 5 : _overlap, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "100px" : _rootMargin;
    var ref1 = (0,react.useState)([]), visibleItems = ref1[0], setVisibleItems = ref1[1];
    var rangeRef = (0,react.useRef)({
        startIndex: 0,
        endIndex: pageSize
    });
    var anchorRef = (0,react.useRef)({
        id: null,
        offsetTop: 0
    });
    // Create a Map to store refs to each list item DOM node
    var itemRefs = (0,react.useRef)(new Map());
    // Sentinels
    var topObserverRef = (0,react.useRef)(null);
    var bottomObserverRef = (0,react.useRef)(null);
    // Use a ref for the handler so the IntersectionObserver doesn't need
    // to be re-created when state/props change.
    var internalDataRef = (0,react.useRef)(data);
    internalDataRef.current = data;
    var canLoadMoreUp = rangeRef.current.startIndex > 0;
    var canLoadMoreDown = rangeRef.current.endIndex < data.length;
    var setItemRef = (0,react.useCallback)(function(id) {
        return function(el) {
            if (el) {
                itemRefs.current.set(id, el);
            } else {
                itemRefs.current.delete(id);
            }
        };
    }, []);
    var handlePageChange = (0,react.useCallback)(function(direction) {
        var container = scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current;
        if (!container) {
            return;
        }
        var _current = rangeRef.current, startIndex = _current.startIndex, endIndex = _current.endIndex;
        var currentData = internalDataRef.current;
        if (direction === "up" && startIndex > 0) {
            var ref;
            // 1. Anchor the current top item to prevent scroll jump
            var firstItemId = (ref = visibleItems[0]) === null || ref === void 0 ? void 0 : ref.id;
            var firstItemEl = itemRefs.current.get(firstItemId);
            if (firstItemEl) {
                anchorRef.current = {
                    id: firstItemId,
                    offsetTop: firstItemEl.offsetTop - container.scrollTop
                };
            }
            // 2. Calculate new range
            var newStart = Math.max(0, startIndex - (pageSize - overlap));
            var newEnd = Math.max(pageSize, startIndex + overlap);
            rangeRef.current = {
                startIndex: newStart,
                endIndex: newEnd
            };
            setVisibleItems(currentData.slice(newStart, newEnd));
        } else if (direction === "down" && endIndex < currentData.length) {
            // 1. Calculate new range
            var newStart1 = Math.max(0, endIndex - overlap);
            var newEnd1 = Math.min(currentData.length, newStart1 + pageSize);
            rangeRef.current = {
                startIndex: newStart1,
                endIndex: newEnd1
            };
            setVisibleItems(currentData.slice(newStart1, newEnd1));
        }
    }, [
        visibleItems,
        scrollContainerRef,
        pageSize,
        overlap
    ]);
    // Handle Scroll Anchoring
    (0,react.useLayoutEffect)(function() {
        if (anchorRef.current.id && scrollContainerRef.current) {
            var container = scrollContainerRef.current;
            var anchorEl = itemRefs.current.get(anchorRef.current.id);
            if (anchorEl) {
                container.scrollTop = anchorEl.offsetTop - anchorRef.current.offsetTop;
            }
            anchorRef.current = {
                id: null,
                offsetTop: 0
            };
        }
    }, [
        visibleItems,
        scrollContainerRef
    ]);
    // The Observer: Only setup ONCE
    (0,react.useEffect)(function() {
        var container = scrollContainerRef.current;
        if (!container) {
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) {
                    return;
                }
                if (entry.target === topObserverRef.current) {
                    ;
                    handlePageChange("up");
                } else if (entry.target === bottomObserverRef.current) {
                    ;
                    handlePageChange("down");
                }
            });
        }, {
            root: container,
            rootMargin: rootMargin,
            threshold: 0
        });
        var top = topObserverRef.current;
        var bottom = bottomObserverRef.current;
        if (top) {
            observer.observe(top);
        }
        if (bottom) {
            observer.observe(bottom);
        }
        return function() {
            return observer.disconnect();
        };
    // dependency array is minimal to prevent observer "flicker"
    }, [
        scrollContainerRef,
        handlePageChange,
        rootMargin
    ]);
    // Sync with external data changes
    (0,react.useEffect)(function() {
        var _current = rangeRef.current, startIndex = _current.startIndex, endIndex = _current.endIndex;
        setVisibleItems(data.slice(startIndex, Math.max(endIndex, pageSize)));
    }, [
        data,
        pageSize
    ]);
    return {
        visibleItems: visibleItems,
        topObserverRef: topObserverRef,
        bottomObserverRef: bottomObserverRef,
        canLoadMoreUp: canLoadMoreUp,
        canLoadMoreDown: canLoadMoreDown,
        setItemRef: setItemRef
    };
};
/* harmony default export */ var lib_useSlidingWindow = (useSlidingWindow);

;// CONCATENATED MODULE: ./components/Lockers/LockerList.js









var PAGE_SIZE = 30;
var OVERLAP = 5; // number of items to overlap between pages for smoother scrolling
var LockerList = function(param) {
    var data = param.data, onLockerSelect = param.onLockerSelect;
    var scrollContainerRef = (0,react.useRef)(null);
    var ref = lib_useSlidingWindow({
        data: data,
        scrollContainerRef: scrollContainerRef,
        pageSize: PAGE_SIZE,
        overlap: OVERLAP
    }), visibleItems = ref.visibleItems, topObserverRef = ref.topObserverRef, bottomObserverRef = ref.bottomObserverRef, canLoadMoreUp = ref.canLoadMoreUp, canLoadMoreDown = ref.canLoadMoreDown, setItemRef = ref.setItemRef;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        ref: scrollContainerRef,
        className: "flex-1 overflow-y-auto min-h-0 max-h-[50vh] scrollbar-none",
        children: [
            canLoadMoreUp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: topObserverRef,
                id: "top-loader",
                className: "h-[1px]"
            }),
            visibleItems.map(function(locker, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                    className: classnames_default()("py-[12px]  hover:bg-[#EEF9FE] cursor-pointer", {
                        "border-b border-[#E6E6E6]": index < data.length - 1
                    }),
                    onClick: function() {
                        return onLockerSelect({
                            marker: locker
                        });
                    },
                    ref: setItemRef(locker.id),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-[8px] flex flex-wrap items-center gap-[8px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardCarrierBadge/* default */.Z, {
                                    locker: locker
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardInactiveTag/* default */.Z, {
                                    locker: locker
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardName/* default */.Z, {
                            locker: locker
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardAddress/* default */.Z, {
                            locker: locker
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardSchedule/* default */.Z, {})
                    ]
                }, locker.id);
            }),
            canLoadMoreDown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: bottomObserverRef,
                id: "bottom-loader",
                className: "h-[1px]"
            })
        ]
    }));
};
/* harmony default export */ var Lockers_LockerList = (LockerList);

// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
;// CONCATENATED MODULE: ./components/Icons/Lockers/DeleteFavouriteLockerIcon.js

var DeleteFavouriteLockerIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20px" : _width, _height = param.height, height = _height === void 0 ? "20px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 20",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "#BC003B",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10 1.25A8.696 8.696 0 0 0 1.25 10 8.696 8.696 0 0 0 10 18.75 8.696 8.696 0 0 0 18.75 10 8.696 8.696 0 0 0 10 1.25Zm0 16.25c-4.125 0-7.5-3.375-7.5-7.5S5.875 2.5 10 2.5s7.5 3.375 7.5 7.5-3.375 7.5-7.5 7.5Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.375 14.375 10 11l-3.375 3.375-1-1L9 10 5.625 6.625l1-1L10 9l3.375-3.375 1 1L11 10l3.375 3.375-1 1Z"
                })
            ]
        })
    });
};
/* harmony default export */ var Lockers_DeleteFavouriteLockerIcon = (DeleteFavouriteLockerIcon);

;// CONCATENATED MODULE: ./components/Icons/Lockers/SaveFavouriteLockerIcon.js

var SaveFavouriteLockerIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "20px" : _width, _height = param.height, height = _height === void 0 ? "20px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 20",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "#319D10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10 2.5c4.13 0 7.5 3.38 7.5 7.5 0 4.13-3.38 7.5-7.5 7.5A7.52 7.52 0 0 1 2.5 10c0-4.13 3.38-7.5 7.5-7.5Zm0-1.25A8.78 8.78 0 0 0 1.25 10 8.78 8.78 0 0 0 10 18.75 8.78 8.78 0 0 0 18.75 10 8.78 8.78 0 0 0 10 1.25Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15 9.38h-4.38V5H9.38v4.38H5v1.24h4.38V15h1.24v-4.38H15V9.38Z"
                })
            ]
        })
    });
};
/* harmony default export */ var Lockers_SaveFavouriteLockerIcon = (SaveFavouriteLockerIcon);

;// CONCATENATED MODULE: ./components/Lockers/LockerCard/LockerCardSaveOrDeleteAction.js




var LockerCardSaveOrDeleteAction = function(param) {
    var onSaveOrDeleteFavouriteLocker = param.onSaveOrDeleteFavouriteLocker, _isFavourite = param.isFavourite, isFavourite = _isFavourite === void 0 ? false : _isFavourite, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex items-center gap-[6px]", {
            "cursor-pointer": !isDisabled,
            "cursor-not-allowed text-[#767676] opacity-60": isDisabled
        }),
        onClick: isDisabled ? undefined : onSaveOrDeleteFavouriteLocker,
        children: [
            isFavourite ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Lockers_DeleteFavouriteLockerIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Lockers_SaveFavouriteLockerIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: isFavourite ? "Sterge ca punct favorit" : "Salveaza ca punct favorit"
            })
        ]
    });
};
/* harmony default export */ var LockerCard_LockerCardSaveOrDeleteAction = (LockerCardSaveOrDeleteAction);

// EXTERNAL MODULE: ./components/Icons/Lockers/SelectedLockerMarkerIcon.js
var SelectedLockerMarkerIcon = __webpack_require__(30247);
// EXTERNAL MODULE: ./components/Lockers/_lib/constants.js
var constants = __webpack_require__(14003);
// EXTERNAL MODULE: ./components/Lockers/_lib/isLockerInactive.js
var isLockerInactive = __webpack_require__(33850);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
;// CONCATENATED MODULE: ./components/Lockers/FavouriteLockerView.js











var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
// the icon default is the altex red, so brico passes its own brand red (red.brand)
var markerColor = isBricoStore ? "#DA281A" : undefined;
var FavouriteLockerView = function(param) {
    var locker = param.locker, onSaveOrDeleteFavouriteLocker = param.onSaveOrDeleteFavouriteLocker;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[16px] flex items-center space-x-[4px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedLockerMarkerIcon/* default */.Z, {
                        color: markerColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardName/* default */.Z, {
                        locker: locker
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardInactiveTag/* default */.Z, {
                        locker: locker
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardAddress/* default */.Z, {
                locker: locker
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardSchedule/* default */.Z, {}),
            (0,isLockerInactive/* default */.Z)(locker) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[6px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    type: "warning",
                    showIcon: true,
                    hasMinWidth: false,
                    children: constants/* FAVOURITE_LOCKER_INACTIVE_MESSAGE */.og
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-[6px] border-t border-[#E5E5E5] mt-[6px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCard_LockerCardSaveOrDeleteAction, {
                    onSaveOrDeleteFavouriteLocker: onSaveOrDeleteFavouriteLocker,
                    isFavourite: true
                })
            })
        ]
    });
};
/* harmony default export */ var Lockers_FavouriteLockerView = (FavouriteLockerView);

// EXTERNAL MODULE: ./store/app/actions.js
var app_actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./components/Lockers/SelectedLockerView.js












var SelectedLockerView = function(param) {
    var locker = param.locker, onSaveOrDeleteFavouriteLocker = param.onSaveOrDeleteFavouriteLocker, onLockerDeselect = param.onLockerDeselect, onLockerSelect = param.onLockerSelect;
    var isInactive = (0,isLockerInactive/* default */.Z)(locker);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-[10px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-red-brand cursor-pointer flex gap-[4px] pb-[20px]",
                onClick: onLockerDeselect,
                children: [
                    "<< ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "underline",
                        children: "Inapoi la lista"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap items-center gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardCarrierBadge/* default */.Z, {
                        locker: locker
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardInactiveTag/* default */.Z, {
                        locker: locker
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardName/* default */.Z, {
                        locker: locker
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardAddress/* default */.Z, {
                        locker: locker
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardSchedule/* default */.Z, {})
                ]
            }),
            isInactive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                type: "warning",
                showIcon: true,
                hasMinWidth: false,
                children: constants/* LOCKER_INACTIVE_MESSAGE */.pM
            }),
            onLockerSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                title: "Selecteaza",
                classesProp: "max-w-fit",
                onClick: onLockerSelect,
                disabled: isInactive
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-[10px] border-y border-[#E6E6E6]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCard_LockerCardSaveOrDeleteAction, {
                    locker: locker,
                    onSaveOrDeleteFavouriteLocker: onSaveOrDeleteFavouriteLocker,
                    isDisabled: isInactive
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LockerCardRoutingAction/* default */.Z, {
                locker: locker
            })
        ]
    }));
};
/* harmony default export */ var Lockers_SelectedLockerView = (SelectedLockerView);

;// CONCATENATED MODULE: ./components/GoogleMap/_lib/getAvailableMarkers.js

var getFilterKeyByActive = function(activeInput) {
    switch(activeInput){
        case "region":
            return "county";
        case "city":
            return "locality";
        case "search":
            return "name";
        default:
            return "";
    }
};
var getAvailableMarkers = function(param) {
    var data = param.data, activeInput = param.activeInput, filter = param.filter;
    if (!(data === null || data === void 0 ? void 0 : data.length) || !activeInput || !filter) return [];
    var normalizedFilter = (0,helpers/* normalizeStringForComparison */.gv)(filter);
    var filterKey = getFilterKeyByActive(activeInput);
    return data.filter(function(item) {
        if (activeInput === "search") {
            return item.name.toLowerCase().includes(normalizedFilter);
        } else {
            var ref;
            var value = (ref = item.address) === null || ref === void 0 ? void 0 : ref[filterKey];
            return (0,helpers/* normalizeStringForComparison */.gv)(value) === normalizedFilter;
        }
    });
};
/* harmony default export */ var _lib_getAvailableMarkers = (getAvailableMarkers);

// EXTERNAL MODULE: ./node_modules/rbush/index.js + 1 modules
var rbush = __webpack_require__(71460);
// EXTERNAL MODULE: ./components/GoogleMap/_lib/getLatLng.js
var getLatLng = __webpack_require__(73445);
;// CONCATENATED MODULE: ./components/GoogleMap/_lib/getMarkerListBounds.js

var getMarkerListBounds = function(data) {
    var bounds = new window.google.maps.LatLngBounds();
    data.forEach(function(item) {
        var ref = (0,getLatLng/* default */.Z)(item), lat = ref.lat, lng = ref.lng;
        if (!isNaN(lat) && !isNaN(lng)) {
            bounds.extend({
                lat: lat,
                lng: lng
            });
        }
    });
    return bounds;
};
/* harmony default export */ var _lib_getMarkerListBounds = (getMarkerListBounds);

;// CONCATENATED MODULE: ./components/GoogleMap/_lib/fitMapToMarkersBounds.js

var fitMapToMarkersBounds = function(param) {
    var markers = param.markers, map = param.map;
    if (!map || !(markers === null || markers === void 0 ? void 0 : markers.length)) {
        return;
    }
    var bounds = _lib_getMarkerListBounds(markers);
    map.fitBounds(bounds);
    if (markers.length === 1) {
        map.setZoom(15);
    }
};
/* harmony default export */ var _lib_fitMapToMarkersBounds = (fitMapToMarkersBounds);

;// CONCATENATED MODULE: ./components/GoogleMap/useVisibleMarkers.js





/**
 * Hook to manage visible markers using spatial indexing (rbush)
 * @param {Object[]} initialData - full marker dataset with .id, .lat, .lng
 * @param {google.maps.Map} map - Google Maps instance
 */ var useVisibleMarkers = function(param) {
    var initialData = param.initialData, map = param.map;
    var ref2 = (0,react.useState)([]), visibleMarkers = ref2[0], setVisibleMarkers = ref2[1];
    var ref1 = (0,react.useState)(false), hasFiltersApplied = ref1[0], setHasFiltersApplied = ref1[1];
    var treeRef = (0,react.useRef)(null);
    var initialVisibleMarkersRef = (0,react.useRef)(null);
    var debouncedUpdateRef = (0,react.useRef)(null);
    var filtersAppliedRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        filtersAppliedRef.current = hasFiltersApplied;
    }, [
        hasFiltersApplied
    ]);
    // Build RBush spatial index whenever data changes
    (0,react.useEffect)(function() {
        if (!(initialData === null || initialData === void 0 ? void 0 : initialData.length)) {
            return;
        }
        var tree = new rbush/* default */.Z();
        var items = initialData.map(function(item) {
            var ref = (0,getLatLng/* default */.Z)(item), lat = ref.lat, lng = ref.lng;
            return {
                minX: lng,
                minY: lat,
                maxX: lng,
                maxY: lat,
                item: item
            };
        });
        tree.load(items);
        treeRef.current = tree;
    }, [
        initialData
    ]);
    // Query visible markers from bounds
    var queryMarkersInBounds = (0,react.useCallback)(function() {
        if (!treeRef.current) {
            return;
        }
        var bounds = map.getBounds();
        if (!bounds) {
            return;
        }
        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();
        return treeRef.current.search({
            minX: sw.lng(),
            minY: sw.lat(),
            maxX: ne.lng(),
            maxY: ne.lat()
        }).map(function(entry) {
            return entry.item;
        });
    }, [
        map
    ]);
    // Update visible markers state
    var updateVisibleMarkers = (0,react.useCallback)(function() {
        if (filtersAppliedRef.current) {
            return; // skip updating from bounds if filters are applied
        }
        var results = queryMarkersInBounds();
        if (results.length) {
            var ref;
            // Save initial markers
            if (!((ref = initialVisibleMarkersRef.current) === null || ref === void 0 ? void 0 : ref.length)) {
                initialVisibleMarkersRef.current = results;
            }
            setVisibleMarkers(results);
        }
    }, [
        queryMarkersInBounds
    ]);
    // Attach debounced listener to map idle
    (0,react.useEffect)(function() {
        if (!map) return;
        debouncedUpdateRef.current = (0,lodash.debounce)(function() {
            if (!map.getBounds() || filtersAppliedRef.current) {
                return;
            }
            updateVisibleMarkers();
        }, 200);
        var listener = map.addListener("idle", debouncedUpdateRef.current);
        return function() {
            var ref;
            listener === null || listener === void 0 ? void 0 : listener.remove();
            (ref = debouncedUpdateRef.current) === null || ref === void 0 ? void 0 : ref.cancel();
            filtersAppliedRef.current = false;
        };
    }, [
        map,
        updateVisibleMarkers
    ]);
    // Geolocation update — re-query visible markers after map pans to user location
    var changeInitialVisibleMarkers = (0,react.useCallback)(function() {
        var results = queryMarkersInBounds();
        if (results === null || results === void 0 ? void 0 : results.length) {
            initialVisibleMarkersRef.current = results;
            setVisibleMarkers(results);
        }
    }, [
        queryMarkersInBounds
    ]);
    var handleVisibleMarkersUpdate = function(markers) {
        var ref;
        (ref = debouncedUpdateRef.current) === null || ref === void 0 ? void 0 : ref.cancel();
        if (markers === null || markers === void 0 ? void 0 : markers.length) {
            setHasFiltersApplied(true);
            _lib_fitMapToMarkersBounds({
                markers: markers,
                map: map
            });
            setVisibleMarkers(markers);
        } else {
            setHasFiltersApplied(false);
            _lib_fitMapToMarkersBounds({
                markers: initialVisibleMarkersRef.current,
                map: map
            });
            setVisibleMarkers(initialVisibleMarkersRef.current);
        }
    };
    return {
        visibleMarkers: visibleMarkers,
        changeInitialVisibleMarkers: changeInitialVisibleMarkers,
        handleVisibleMarkersUpdate: handleVisibleMarkersUpdate
    };
};
/* harmony default export */ var GoogleMap_useVisibleMarkers = (useVisibleMarkers);

// EXTERNAL MODULE: ./node_modules/@googlemaps/markerclusterer/dist/index.esm.mjs + 3 modules
var index_esm = __webpack_require__(95936);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/GoogleMap/useMarkersClusterer.js






var useMarkersClusterer = function(param1) {
    var map = param1.map, data = param1.data, _clustererOptions = param1.clustererOptions, clustererOptions = _clustererOptions === void 0 ? {
        radius: 200,
        maxZoom: 17
    } : _clustererOptions, clustererIcon = param1.clustererIcon, mapMarkerIcon = param1.mapMarkerIcon;
    var ref = (0,react.useState)(null), selectedMarker = ref[0], setSelectedMarker = ref[1];
    var markersLibrary = (0,index_modern/* useMapsLibrary */.kY)("marker");
    var clustererRef = (0,react.useRef)(null);
    var markersRef = (0,react.useRef)(new Map());
    var markerContentCache = (0,react.useRef)(new Map());
    var handleMarkerSelect = (0,react.useCallback)(function(param) {
        var markerInstance = param.markerInstance, marker = param.marker;
        map.panTo((0,getLatLng/* default */.Z)(marker));
        setSelectedMarker({
            markerInstance: markerInstance || markersRef.current.get(marker.id),
            marker: marker
        });
    }, [
        map
    ]);
    var onMarkerDeselect = (0,react.useCallback)(function() {
        setSelectedMarker(null);
    }, []);
    var renderMarkerIcon = (0,react.useCallback)(function(item) {
        if (markerContentCache.current.has(item.id)) {
            return markerContentCache.current.get(item.id);
        }
        var MapMarkerComponent = /*#__PURE__*/ (0,react.memo)(mapMarkerIcon);
        var container = document.createElement("div");
        react_dom.render(/*#__PURE__*/ (0,jsx_runtime.jsx)(MapMarkerComponent, {
            marker: {
                provider: item.provider,
                status: item.status
            }
        }), container);
        markerContentCache.current.set(item.id, container);
        return container;
    }, [
        mapMarkerIcon
    ]);
    (0,react.useEffect)(function() {
        if (!map || !markersLibrary || !(data === null || data === void 0 ? void 0 : data.length)) {
            return;
        }
        if (!clustererRef.current) {
            clustererRef.current = new index_esm/* MarkerClusterer */.XL({
                map: map,
                markers: [],
                algorithm: new index_esm/* SuperClusterAlgorithm */.dO(clustererOptions),
                renderer: clustererIcon({
                    markersLibrary: markersLibrary
                })
            });
        }
        var markersToAdd = [];
        var markersToRemove = [];
        // ADD
        data.forEach(function(item) {
            var currentMarkerInstance = markersRef.current.get(item.id);
            if (!currentMarkerInstance) {
                var marker = new markersLibrary.AdvancedMarkerElement({
                    map: map,
                    position: (0,getLatLng/* default */.Z)(item),
                    content: renderMarkerIcon(item),
                    collisionBehavior: "OPTIONAL_AND_HIDES_LOWER_PRIORITY"
                });
                marker.addListener("gmp-click", function() {
                    return handleMarkerSelect({
                        markerInstance: marker,
                        marker: item
                    });
                });
                markersRef.current.set(item.id, marker);
                markersToAdd.push(marker);
            } else {
                markersToAdd.push(currentMarkerInstance);
            }
        });
        // REMOVE
        markersRef.current.forEach(function(marker, id) {
            if (!data.find(function(item) {
                return item.id === id;
            })) {
                markersToRemove.push(marker);
            }
        });
        if (markersToRemove.length) {
            clustererRef.current.removeMarkers(markersToRemove, true);
        }
        if (markersToAdd.length) {
            clustererRef.current.addMarkers(markersToAdd, true);
        }
        clustererRef.current.render();
    }, [
        data,
        map,
        markersLibrary
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (clustererRef.current) {
                clustererRef.current.clearMarkers();
                clustererRef.current.setMap(null);
                clustererRef.current = null;
            }
            if (markersRef.current) {
                markersRef.current.forEach(function(marker) {
                    marker.map = null;
                });
                markersRef.current = new Map();
            }
        };
    }, []);
    return {
        selectedMarker: selectedMarker,
        onMarkerDeselect: onMarkerDeselect,
        onMarkerSelect: handleMarkerSelect
    };
};
/* harmony default export */ var GoogleMap_useMarkersClusterer = (useMarkersClusterer);

;// CONCATENATED MODULE: ./components/Lockers/LockersClustererIcon.js
var getColor = function(count) {
    if (count < 10) return "#9CB6E4"; // light blue
    if (count < 50) return "#83A4DD"; // medium blue
    return "#6D93D7"; // dark blue
};
var LockersClustererIcon = function(param1) {
    var markersLibrary = param1.markersLibrary;
    return {
        render: function render(param) {
            var count = param.count, position = param.position;
            var div = document.createElement("div");
            var span = document.createElement("span");
            var bgColor = getColor(count);
            span.style.backgroundColor = bgColor;
            span.style.color = "#ffffff";
            span.style.borderRadius = "9999px";
            span.style.width = "36px";
            span.style.height = "36px";
            span.style.display = "flex";
            span.style.alignItems = "center";
            span.style.justifyContent = "center";
            span.style.fontSize = "13px";
            span.style.fontWeight = "600";
            span.textContent = count;
            // Set box-sizing so border doesn't affect size
            div.style.boxSizing = "border-box";
            div.style.backgroundColor = "rgba(131, 164, 221, 0.5)";
            div.style.borderRadius = "9999px";
            div.style.padding = "8px";
            div.appendChild(span);
            return new markersLibrary.AdvancedMarkerElement({
                position: position,
                content: div
            });
        }
    };
};
/* harmony default export */ var Lockers_LockersClustererIcon = (LockersClustererIcon);

// EXTERNAL MODULE: ./store/stores/actions.js
var stores_actions = __webpack_require__(76208);
// EXTERNAL MODULE: ./lib/clientStore.js
var clientStore = __webpack_require__(66208);
;// CONCATENATED MODULE: ./components/LockersMapWithFilters/index.js

























function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var GoogleMap = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 6208).then(__webpack_require__.bind(__webpack_require__, 26208));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26208)
            ];
        }
    },
    ssr: false
});
var LockersMapWithFilters_ref = (0,config["default"])(), LockersMapWithFilters_publicRuntimeConfig = LockersMapWithFilters_ref.publicRuntimeConfig, googleMapsCloudId = LockersMapWithFilters_publicRuntimeConfig.google.googleMapsCloudId;
var LockersMapWithFilters = /*#__PURE__*/ (0,react.memo)(function(param1) {
    var user = param1.user, addAlert1 = param1.addAlert, mapId = param1.mapId, getLockersList1 = param1.getLockersList, getRegions1 = param1.getRegions, setFavouriteLockerId1 = param1.setFavouriteLockerId, initialData = param1.lockers, regions = param1.regions, onLockerSelect = param1.onLockerSelect;
    var ref6;
    var map = (0,index_modern/* useMap */.Sx)(mapId);
    var customer = user.customer, isLoggedIn = user.isLoggedIn;
    var customerFavoriteLockerId = (customer === null || customer === void 0 ? void 0 : customer.locker_id) || clientStore/* localClientStore.get */.C.get("favourite_locker_id");
    var filteredLockersRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        var getData = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var promises;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            promises = [];
                            if (!(initialData === null || initialData === void 0 ? void 0 : initialData.length)) {
                                promises.push(getLockersList1());
                            }
                            if (!(regions === null || regions === void 0 ? void 0 : regions.length)) {
                                promises.push(getRegions1());
                            }
                            if (!promises.length) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 7;
                            return Promise.all(promises);
                        case 7:
                            setIsLoading(false);
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!(initialData === null || initialData === void 0 ? void 0 : initialData.length) || !(regions === null || regions === void 0 ? void 0 : regions.length)) {
            getData();
        }
    }, []);
    var ref2 = GoogleMap_useVisibleMarkers({
        initialData: initialData,
        map: map
    }), visibleMarkers = ref2.visibleMarkers, changeInitialVisibleMarkers = ref2.changeInitialVisibleMarkers, handleVisibleMarkersUpdate = ref2.handleVisibleMarkersUpdate;
    // selectedMarker should contain both the marker instance and the marker data
    var ref3 = GoogleMap_useMarkersClusterer({
        map: map,
        data: visibleMarkers,
        mapMarkerIcon: LockerMarker,
        clustererIcon: Lockers_LockersClustererIcon
    }), selectedMarker = ref3.selectedMarker, onMarkerSelect = ref3.onMarkerSelect, onMarkerDeselect = ref3.onMarkerDeselect;
    var customerFavoriteLocker = (0,react.useMemo)(function() {
        return customerFavoriteLockerId && (initialData === null || initialData === void 0 ? void 0 : initialData.length) ? initialData.find(function(locker) {
            return locker.id === customerFavoriteLockerId;
        }) : null;
    }, [
        customerFavoriteLockerId,
        initialData
    ]);
    var handleFiltersChange = function(param) {
        var value = param.value, active = param.active;
        if (!filteredLockersRef.current) {
            filteredLockersRef.current = {};
        }
        switch(active){
            case "region":
                {
                    // when user selects a region, filter regions from all lockers list
                    if (value && value !== "all_regions") {
                        var filteredLockers = _lib_getAvailableMarkers({
                            data: initialData,
                            activeInput: active,
                            filter: value
                        });
                        filteredLockersRef.current = {
                            region: filteredLockers
                        };
                        handleVisibleMarkersUpdate(filteredLockers);
                    } else if (value === "all_regions") {
                        filteredLockersRef.current = null;
                        handleVisibleMarkersUpdate();
                    }
                    break;
                }
            case "city":
                {
                    // when user selects a city, we filter based on the previously filtered list by region
                    // if no region is seleced, city field is disabled
                    if (value && value !== "all_cities") {
                        var filteredLockers1 = _lib_getAvailableMarkers({
                            data: filteredLockersRef.current.region,
                            activeInput: active,
                            filter: value
                        });
                        filteredLockersRef.current = _objectSpread({}, filteredLockersRef.current, {
                            city: filteredLockers1
                        });
                        handleVisibleMarkersUpdate(filteredLockers1);
                    } else if (value === "all_cities") {
                        filteredLockersRef.current = {
                            region: filteredLockersRef.current.region
                        };
                        handleVisibleMarkersUpdate(filteredLockersRef.current.region);
                    }
                    break;
                }
            case "search":
                {
                    if (value && value.trim().length > 2) {
                        // when user enters a search term, we search based on the previously filtered list
                        // if we have city, search in city, otherwise if we have region, search in region list,
                        // otherwise we search based on all lockers list
                        (0,lodash.debounce)(function() {
                            var ref9, ref5;
                            var visibleLockers = _lib_getAvailableMarkers({
                                data: ((ref9 = filteredLockersRef.current) === null || ref9 === void 0 ? void 0 : ref9.city) ? filteredLockersRef.current.city : ((ref5 = filteredLockersRef.current) === null || ref5 === void 0 ? void 0 : ref5.region) ? filteredLockersRef.current.region : initialData,
                                activeInput: active,
                                filter: value
                            });
                            if (visibleLockers === null || visibleLockers === void 0 ? void 0 : visibleLockers.length) {
                                filteredLockersRef.current = _objectSpread({}, filteredLockersRef.current, {
                                    search: visibleLockers
                                });
                                handleVisibleMarkersUpdate(visibleLockers);
                            }
                        }, 500)();
                    } else if (value === "") {
                        var ref7;
                        // if we have region we could have city as well
                        // if search is cleared, we want to reset to the previous list based on region/city filters
                        if ((ref7 = filteredLockersRef.current) === null || ref7 === void 0 ? void 0 : ref7.region) {
                            var ref4;
                            filteredLockersRef.current = _objectSpread({
                                region: filteredLockersRef.current.region
                            }, filteredLockersRef.current.city && {
                                city: filteredLockersRef.current.city
                            });
                            handleVisibleMarkersUpdate(((ref4 = filteredLockersRef.current) === null || ref4 === void 0 ? void 0 : ref4.city) ? filteredLockersRef.current.city : filteredLockersRef.current.region);
                        } else {
                            // if no region or city filters, we reset to all lockers list and fit map to default position
                            filteredLockersRef.current = null;
                            handleVisibleMarkersUpdate();
                        }
                    }
                    break;
                }
            default:
                break;
        }
    };
    var handleSaveOrDeleteFavouriteLocker = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var action, payload, response, ref10;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        action = param.action;
                        if (!(action !== "delete" && (0,isLockerInactive/* default */.Z)(selectedMarker === null || selectedMarker === void 0 ? void 0 : selectedMarker.marker))) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", addAlert1({
                            message: constants/* LOCKER_INACTIVE_MESSAGE */.pM,
                            variant: "warning"
                        }));
                    case 3:
                        setIsLoading(true);
                        if (!isLoggedIn) {
                            _ctx.next = 12;
                            break;
                        }
                        payload = action === "delete" ? null : selectedMarker.marker.id;
                        _ctx.next = 8;
                        return setFavouriteLockerId1(payload);
                    case 8:
                        response = _ctx.sent;
                        if ((response === null || response === void 0 ? void 0 : response.status) === "success") {
                            ;
                            if (selectedMarker) {
                                onMarkerDeselect();
                            }
                            addAlert1({
                                message: ((ref10 = response.messages) === null || ref10 === void 0 ? void 0 : ref10[0]) || (action === "delete" ? "Punctul favorit a fost șters." : "Punctul a fost salvat ca favorit."),
                                variant: "success"
                            });
                        } else {
                            addAlert1({
                                message: action === "delete" ? "Nu am putut sterge punctul favorit." : "Nu am putut salva punctul favorit.",
                                variant: "error"
                            });
                        }
                        _ctx.next = 13;
                        break;
                    case 12:
                        {
                            if (action === "add") {
                                setFavouriteLockerId1(selectedMarker.marker.id);
                            }
                            if (action === "delete") {
                                setFavouriteLockerId1(null);
                            }
                            if (selectedMarker) {
                                onMarkerDeselect();
                            }
                        }
                    case 13:
                        setIsLoading(false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSaveOrDeleteFavouriteLocker(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleGeolocationChange = (0,react.useCallback)(function() {
        changeInitialVisibleMarkers();
    }, [
        changeInitialVisibleMarkers
    ]);
    var handleLockerSelect = (0,react.useCallback)(function() {
        // The disabled buttons are the UI, this guard is the contract
        if ((0,isLockerInactive/* default */.Z)(selectedMarker === null || selectedMarker === void 0 ? void 0 : selectedMarker.marker)) {
            return addAlert1({
                message: constants/* LOCKER_INACTIVE_MESSAGE */.pM,
                variant: "warning"
            });
        }
        onLockerSelect(selectedMarker.marker);
    }, [
        addAlert1,
        onLockerSelect,
        selectedMarker
    ]);
    if (!isLoading && !(initialData === null || initialData === void 0 ? void 0 : initialData.length)) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-center w-full h-[300px] border border-gray-1100 mt-[32px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-center text-gray-1200",
                children: "Nu am putut prelua lista cu punctele de livrare. Te rugam sa incerci din nou mai tarziu."
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:flex-row-reverse w-full h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[60vh] md:h-[80vh]",
                children: initialData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMap, {
                    mapId: mapId,
                    mapCloudId: googleMapsCloudId,
                    infoWindow: {
                        content: LockerInfoWindowContent,
                        header: LockerInfoWindowHeader
                    },
                    onMarkerDeselect: onMarkerDeselect,
                    selectedMarker: selectedMarker,
                    onGeolocationChange: handleGeolocationChange
                })
            }),
            initialData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col pr-[16px] w-full h-[60vh] lg:h-[80vh] lg:w-[40%] xl:w-[30%] bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMap_GoogleMapFilters, {
                        data: ((ref6 = filteredLockersRef.current) === null || ref6 === void 0 ? void 0 : ref6.region) || initialData,
                        onFiltersChange: handleFiltersChange
                    }),
                    customerFavoriteLocker && !selectedMarker && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-[12px] ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lockers_FavouriteLockerView, {
                            locker: customerFavoriteLocker,
                            onSaveOrDeleteFavouriteLocker: function() {
                                return handleSaveOrDeleteFavouriteLocker({
                                    action: "delete"
                                });
                            }
                        })
                    }),
                    selectedMarker ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[20px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Lockers_SelectedLockerView, {
                            locker: selectedMarker.marker,
                            onSaveOrDeleteFavouriteLocker: function() {
                                return handleSaveOrDeleteFavouriteLocker({
                                    action: "add"
                                });
                            },
                            onLockerDeselect: onMarkerDeselect,
                            onLockerSelect: onLockerSelect ? handleLockerSelect : null
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Lockers_LockerList, {
                        data: visibleMarkers,
                        onLockerSelect: onMarkerSelect
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute flex items-center justify-center inset-0 bg-white opacity-60",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                    height: 100
                })
            })
        ]
    }));
});
LockersMapWithFilters.displayName = "LockersMapWithFilters";
/* harmony default export */ var components_LockersMapWithFilters = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user,
        lockers: state.stores.lockers,
        regions: state.user.regions
    };
}, {
    apiCall: app_actions/* apiCall */.k_,
    addAlert: app_actions/* addAlert */.V_,
    getLockersList: stores_actions/* getLockersList */.MM,
    getRegions: actions/* getRegions */.JL,
    setFavouriteLockerId: actions/* setFavouriteLockerId */.Gx
})(LockersMapWithFilters));

;// CONCATENATED MODULE: ./components/LockersMapWithFilters/LockersMapWithFiltersModal.js



var LockersMapWithFiltersModal = function(param) {
    var modalId = param.modalId, mapId = param.mapId, header = param.header, onLockerSelect = param.onLockerSelect;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Modal["default"], {
        id: modalId,
        size: "large",
        header: header || "Alege un punct de ridicare favorit",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LockersMapWithFilters, {
            mapId: mapId,
            onLockerSelect: onLockerSelect
        })
    });
};
/* harmony default export */ var LockersMapWithFilters_LockersMapWithFiltersModal = (LockersMapWithFiltersModal);


/***/ }),

/***/ 76208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r8": function() { return /* binding */ getStores; },
/* harmony export */   "y3": function() { return /* binding */ getStoreByUrlPath; },
/* harmony export */   "MM": function() { return /* binding */ getLockersList; }
/* harmony export */ });
/* unused harmony export getUserLocation */
/* harmony import */ var _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69170);
/* harmony import */ var _lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45963);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2642);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);




var getStores = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES */ .lc,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES_SUCCESS */ .B6,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORES_FAILURE */ .Md
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            // spinnerMessage: "Loading stores list",
            alert: false,
            // alertMessage: `Get stores couldn't be completed...`,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getStoresApi */ .n5p,
            apiArgs: [],
            formatResponse: function(response) {
                return response.data.stores;
            }
        });
    };
};
var getStoreByUrlPath = function(urlPath) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH */ .fw,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH_SUCCESS */ .F0,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_STORE_BY_URL_PATH_FAILURE */ .o8
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            spinnerMessage: "Se incarca lista magazinelor",
            alert: false,
            // alertMessage: `Get stores couldn't be completed...`,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getStoreByUrlPathApi */ .XM9,
            apiArgs: [
                encodeURIComponent(urlPath)
            ],
            formatResponse: function(response) {
                return {
                    store: response.data.stores[0]
                };
            }
        });
    };
};
var getUserLocation = function() {
    return function(dispatch) {
        // Dispatch get user location action
        dispatch({
            type: GET_USER_LOCATION
        });
        // Check if browser has geolocation support and is enabled
        getBrowserGeolocation().then(function(result) {
            dispatch({
                type: GET_USER_LOCATION_SUCCESS,
                payload: result
            });
        }).catch(function(error) {
            // Catch error and dispatch get user location failure
            dispatch({
                type: GET_USER_LOCATION_FAILURE,
                error: error.message
            });
        });
    };
};
var getLockersList = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST */ .nv,
                success: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST_SUCCESS */ .DP,
                fail: _store_stores_constants__WEBPACK_IMPORTED_MODULE_3__/* .GET_LOCKERS_LIST_FAILURE */ .IM
            },
            dispatch: dispatch,
            getState: getState,
            spinner: false,
            alert: false,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getLockersApi */ .p5Y,
            apiArgs: [],
            formatResponse: function(response) {
                return response.data.data.lockers;
            }
        });
    };
};


/***/ })

}]);